<template>
    <div>

        <router-link class="small text-dark mb-32 d-flex" :to="{ name: 'onboarding-personal' }">
            <i-back class="i-14 mr-16 fill-gold my-auto"></i-back>
            {{ $t('general.back')}}
        </router-link>

        <h1 class="mb-32">{{ $t('pages.onboarding-medical.title') }}</h1>
        <el-form @submit="submit" class="pb-32">

            <template slot="default">

                <el-error class="mb-16" :error="server_error"></el-error>

                <div class="row mb-32">
                    <div class="col-12 ">
                        <p class="fw-b mb-16">{{ $t('pages.onboarding-medical.medical_complaint_title') }}</p>
                    </div>
                    <el-medical-compaints class="col-12 col-lg-7 mb-32" v-model="data.medical_complaint_ids" :user_id="currentUser.user.id"></el-medical-compaints>
                </div>

                <p class="fw-b mb-16">{{ $t('pages.onboarding-medical.sleep_medication') }}</p>

                <el-medication-minimised v-model="data.medication" :type="medicationTypes.find((mt) => mt.name === 'medication_types.sleep_medication').id"></el-medication-minimised>
                <p class="fw-b mt-16 mb-0">{{ $t('pages.onboarding-medical.other_medication') }}</p>
                <div class="form-row mb-16 mt-0">
                    <div class="col-12">
                        <p-check v-model="data.other_medicine" class="p-curve p-svg p-jelly small text-wrap" color="primary" name="check">
                            <i-check slot="extra" class="svg svg-icon"></i-check>
                            {{ $t('pages.onboarding-medical.i_take_other_medication') }}
                        </p-check>
                    </div>
                </div>
                <el-medication-minimised v-if="data.other_medicine" name="other_medication_name" rule="required" v-model="data.non_sleep_medication" :type="medicationTypes.find((mt) => mt.name === 'medication_types.other_medication').id"></el-medication-minimised>

            </template>

            <template slot="footer">
                <div class="d-flex flex-lg-row-reverse flex-column">
                    <button class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex ml-lg-8" v-bind:class="{ disabled : loading  }" @click="trial = false">
                        {{ $t('general.start_today') }}
                        <template v-if="loading">
                            <i-loader class="ml-2 i-20 my-auto"></i-loader>
                        </template>
                        <template v-if="success">
                            <i-check class="ml-2 i-20 my-auto"></i-check>
                        </template>
                    </button>
                    <button class="btn btn-light btn-block btn-lg-inline d-block d-lg-flex ml-auto" v-bind:class="{ disabled : loading  }" @click="trial = true">
                        {{ $t('general.start_trial') }}
                        <template v-if="trialLoading">
                            <i-loader class="ml-2 i-20 my-auto fill-gray"></i-loader>
                        </template>
                        <template v-if="trialSuccess">
                            <i-check class="ml-2 i-20 my-auto"></i-check>
                        </template>
                    </button>
                </div>
            </template>

        </el-form>
    </div>
</template>

<script>
import { ElMedicationMinimised, ElForm, PCheck, ElError, ElMedicalCompaints } from '@/components/forms'

export default {
    name: 'page-onboarding-medical',

    components: { ElMedicationMinimised, ElForm, PCheck, ElError, ElMedicalCompaints },

    data: () => ({
        loading: false,
        success: false,
        trialLoading: false,
        trialSuccess: false,
        server_error: null,
        update: false,
        trial: false,

        data: {
            other_medicine: false,
            medication: [{ name: "", medication_type_id: 1 }],
            non_sleep_medication: [{ name: "", medication_type_id: 2 }],
            medical_complaint_ids: [],
        }
    }),

    mounted() {
        this.$store.dispatch('general/medicationTypes')

        if (this.currentUser.user && this.currentUser.user.medical_info_id)
            this.$store.dispatch('user/readMedicalInfo', { user_id: this.currentUser.user.id, id: this.currentUser.user.medical_info_id }).then((medicalInfo) => {
                this.data.id = medicalInfo.id
                this.data.other_medicine = medicalInfo.other_medicine

                this.data.medication = this.readAPIMedication(medicalInfo.medication, 1)
                this.data.non_sleep_medication = this.readAPIMedication(medicalInfo.medication, 2)
                this.data.medical_complaint_ids = medicalInfo.medical_complaint_ids

                this.data.medication.push({ name: "", medication_type_id: 1 })
                this.data.non_sleep_medication.push({ name: "", medication_type_id: 2 })
                this.update = true
            })
    },

    methods: {
        submit() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    if (this.trial) {
                        this.trialLoading = true
                    } else {
                        this.loading = true
                    }
                    let data = Object.assign({}, this.data)
                    let user_id = this.currentUser.user.id
                    data.medication = [...this.parseApiMedication(data.medication), ...this.parseApiMedication(data.non_sleep_medication)]
                    this.$store.dispatch(`user/${!this.update ? 'createMedicalInfo' : 'updateMedicalInfo'}`, { user_id, data }).then(
                        () => {
                            if (this.trial) {
                                this.trialLoading = false
                                this.trialSuccess = true
                            } else {
                                this.loading = false
                                this.success = true
                            }

                            if (this.$root.sizer !== 'sm')
                                localStorage.removeItem('vue-tour-viewed')
                            if (this.trial) {
                                this.$router.push({ name: 'sleep-schedule' })
                            } else {
                                this.$router.push({ name: 'sleep-schedule', query: { payment: true } })
                            }
                        },
                        error => {
                            if (this.trial) {
                                this.trialLoading = true
                                this.trialSuccess = false
                            } else {
                                this.loading = false
                                this.success = false
                            }
                            this.server_error = error
                        }
                    )
                }
            })
        },

        readAPIMedication(medication, type) {
            let result = []
            medication.forEach((meds) => {
                if (meds.medication_type_id === type)
                    result.push({
                        name: meds.name,
                        medication_type_id: meds.medication_type_id,
                    })
            })
            return result
        },
        parseApiMedication(medication) {
            let result = []
            medication.forEach((meds) => {
                if (meds.name !== '')
                    result.push({ name: meds.name, medication_type_id: meds.medication_type_id, })
            })
            return result
        }
    },
    computed: {
        currentUser() {
            return this.$store.getters['user/currentUser']
        },
        personTypes() {
            return this.$store.getters['general/personTypes']
        },
        medicationTypes() {
            return this.$store.getters['general/medicationTypes']
        }
    }
}
</script>
